var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdjustments({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H4M6 12C6 13.1046 6.89543 14 8 14C9.10457 14 10 13.1046 10 12M6 12C6 10.8954 6.89543 10 8 10C9.10457 10 10 10.8954 10 12M18 18C18 16.8954 17.1046 16 16 16C14.8954 16 14 16.8954 14 18M18 18C18 19.1046 17.1046 20 16 20C14.8954 20 14 19.1046 14 18M18 18H20M14 18H4M10 12H20M18 6C18 4.89543 17.1046 4 16 4C14.8954 4 14 4.89543 14 6M18 6C18 7.10457 17.1046 8 16 8C14.8954 8 14 7.10457 14 6M18 6L20 6M14 6H4",
    stroke: "#4B5563",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdjustments);
export default __webpack_public_path__ + "static/media/Adjustments.37e8268551e307a6fcde010ff1162967.svg";
export { ForwardRef as ReactComponent };